'use client'
import React, {useCallback, useState} from "react";
import styled from "styled-components";
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {Img} from "@/components/Img";
import useDeviceTypeMobile from "@/components/hooks/useDeviceTypeMobile";
import Slider, {Slide} from "@/components/swiper";
import ThemeContainer from "@/components/theme/container";
import SweeperNav from "@/components/swiper/SweeperNav";
import {Col, Container, Row} from "react-bootstrap";
import SliderItem from "@/components/home/single/SliderItem";
import useViewportHeight from "@/components/hooks/useViewportHeight";
import Button from "@/components/Button";
import {hover, white} from "@/styles/globalStyleVars";
import useContainerOffset from "@/components/hooks/useContainerOffset";
import Title from "@/components/Title";
import PopupForms from "@/components/PopupForms";



const DropRequirements = ({data}) => {
    const offset = useContainerOffset('.container');


    const [show, setShow] = useState(false);
    const [popupId, setPopupId] = useState()

    const handleClose = () => setShow(false);
    const handleShow = (data) => {
        setShow(true);
        setPopupId(data); // Set popupId to the data object
    };


    return (
        <StyledBanner offset={offset} className={'drop_your_requirments'}>
            <Img parallax src={'/images/dynamic/post-property.webp'}/>
            <Container>
                <Row>
                    <Col md={5}>
                        <div className="drop_requirments_wrapper">
                            <Title color={'white'} fontSize={40} lineHeight={40}  text={'Want to sell or rent out your property?'}/>

                            <p>Our professional team can help you out. Post your property details now.</p>

                            <div onClick={(e) => handleShow(e)}>
                                <Button text={'Drop Your Requirements'} src={"javascript:void(0)"} margin={'30px 0 0'}
                                        border={`1px`}
                                        borderColor={`${white}`}
                                        hoverBackground={`${hover}`}
                                        color={`${white}`}
                                        padding={'10px 20px'}
                                />
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>

            <PopupForms  show={show} data={popupId} handleClose={handleClose}/>
        </StyledBanner>
    );
};

const StyledBanner = styled.section`
    position: relative;
    overflow: hidden;
    height: 100svh;

    .container{
        position: absolute;
        top: 50%;
        padding-left: ${probs => probs.offset ? probs.offset + 15 : ''}px;;
        transform: translateY(-50%);
        
        @media(max-width: 767px){
            transform: unset;
            top: unset;
            bottom: 30px;
        }
    }
    .drop_requirments_wrapper {
        background: #005E9E;
        padding: 50px;

        @media(max-width: 767px){
            padding: 30px;
        }
        h2 {
            font-weight: 800;
        }

        p {
            color: white;
        }
    }
`;

export default React.memo(DropRequirements);
